( function () {
	'use strict';

	function quickAccess ( $document, apiService, $filter, TOOLTIP_MESSAGES ) {
		function link ( scope ) {
			scope.collapse  = true;
			scope.prevQuick = '';
			// this is for the notification
			scope.activeTimerCount = 0;
			scope.tooltip          = TOOLTIP_MESSAGES;

			var evidences = angular.copy( scope.model.masterEvidences );
			var container = angular.element( document.getElementById( 'quick-access-container' ) );

			function filterItem ( type ) {
				return function ( item ) {
					return item.type === type;
				};
			}

			scope.filterItem = filterItem;
			scope.timer      = $filter( 'filter' )( evidences, filterItem( 7 ) ).reverse();
			scope.counter    = $filter( 'filter' )( evidences, filterItem( 6 ) ).reverse();

			scope.scrollToElement = function ( type ) {
				var quickAccessElement = {
					'6' : angular.element( document.getElementById( 'quick-access-counter-label' ) ),
					'7' : angular.element( document.getElementById( 'quick-access-timer-label' ) )
				};

				container.scrollTo( quickAccessElement[ type ], 0 );
			};

			scope.addElement = function ( type ) {
				var evidence = {
					'6' : [ 'counter', '0', 'Counter ' ],
					'7' : [ 'timer', '00:00:00.00', 'Timer ' ]
				};

				var loading   = evidence[ type ][ 0 ] + 'Loading';
				var length    = scope[ evidence[ type ][ 0 ] ].length + 1;
				var currentEv = {
					'id'          : apiService.generateUUID(),
					'scope'       : 'public',
					'type'        : type,
					'description' : evidence[ type ][ 1 ],
					'name'        : evidence[ type ][ 2 ] + length
				};

				scope.showLoading = true;
				scope[ loading ]  = true;

				scope.model.masterEvidences.push( currentEv );

				scope.scrollToElement( type );

				scope.$root.$broadcast( 'updateObs', {
					'activeTimer'  : false,
					'type'         : type,
					'evidenceData' : currentEv
				} );

				if ( type === 7 ) {
					scope.$root.$broadcast( 'add:timer', currentEv, true );
				}
			};

			scope.$on( 'enable:timer:counter:buttons', function ( ev, obj ) {
				var type = {
					'6' : 'counter',
					'7' : 'timer'
				};

				var loading = type[ obj.type ] + 'Loading';

				scope[ type[ obj.type ] ].unshift( obj.evidenceData );
				scope[ loading ] = false;

				scope.showLoading = false;

				scope.scrollToElement( obj.type );
			} );
		}

		var directive = {
			'link'        : link,
			'restrict'    : 'E',
			'templateUrl' : '/templates/observations/observation-edit/quick-access/quick-access.html',
			'scope'       : {
				'model'  : '=',
				'update' : '&',
				'timers' : '=',
				'nav'    : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.observations' )
		.directive( 'quickAccess', quickAccess );

	quickAccess.$inject = [ '$document', 'apiService', '$filter', 'TOOLTIP_MESSAGES' ];
} )( );
